export interface IContact {
    contactId: string;
    phoneBookId: string;
    name: string;
    familyName: string;
    defaultNumber: string;
    number2: string;
    number3: string;
    number4: string;
    isActive: boolean;
    isPin: boolean;
    isStar: boolean;
    isInBlackList: boolean;
    color: string;
    contactCategoryIds: string[];
}


export class Contact implements IContact {
    contactId = "";
    phoneBookId = "";
    name = "";
    familyName = "";
    defaultNumber = "";
    number2 = "";
    number3 = "";
    number4 = "";
    isActive = false;
    isPin = false;
    isStar = false;
    isInBlackList = false;
    color = "";
    contactCategoryIds = [];
    contactList: IContact[] = []

    constructor(contactList: any[]) {
        this.fillContactList(contactList)
    }

    fillContactList(contactLis: any[]) {
        this.contactList = []
        contactLis.forEach((item: any) => {
            let tempModel: IContact = {
                contactId: item.contactId,
                phoneBookId: item.phoneBookId,
                name: item.name,
                familyName: item.familyName,
                defaultNumber: item.defaultNumber,
                number2: item.number2,
                number3: item.number3,
                number4: item.number4,
                isActive: item.isActive,
                isPin: item.isPin,
                isStar: item.isStar,
                isInBlackList: item.isInBlackList,
                color: item.color,
                contactCategoryIds: item.contactCategoryIds
            }
            this.contactList.push(tempModel)
        })
    }

}

export class IContactDataObject {
    data: IContact[] = [];
    pageNumber = 1;
    pageSize = 10;
    totalCount = null;

}
export class ContactDataObject {
    data: IContact[] = [];
    pageNumber = 1;
    pageSize = 10;
    totalCount = null;
    constructor(response: any) {
        this.data = response.data;
        this.pageNumber = response.pageNumber;
        this.totalCount = response.totalCount > 0 ? response.totalCount : null
    }



}

export interface ContactCategory {
    id: string,
    name: string
}

export class ContactCategoryDataObject {
    data: ContactCategory[] = [];
    pageNumber = 1;
    pageSize = 10;
    totalCount = 0;
}

export interface PhoneBook {
    id: string,
    name: string
}

export class PhoneBookDataObject {
    data: PhoneBook[] = [];
    pageNumber = 1;
    pageSize = 10;
    totalCount = null;
    constructor(data: any) {
        this.fillData(data.data)
        this.pageNumber = data.pageNumber;
        this.pageSize = data.pageSize
        this.totalCount = data.totalCount > 0 ? data.totalCount : null
    }

    fillData(list: any[]) {
        this.data = [];
        list.forEach((item: any) => {
            let tempModel: PhoneBook = {
                id: item.id,
                name: item.name
            }
            this.data.push(tempModel)
        })
    }
}



export interface ContactState {
    getContactCallDirectPending: boolean,
    getContactCallDirectError: string|null,
    contactsCallDirect:IContactDataObject,

    contactList: IContactDataObject,
    contacts: IContactDataObject,
    unpagedContacts: IContactDataObject,
    getContactsPending: boolean,
    getContactsByPhonBookIdPending: boolean,
    contactListByPhoneBook: IContact[],
    addContactPending: boolean,
    addContactSuccess: boolean,
    updateContactPending: boolean,
    updateContactSuccess: boolean,
    removeFromPhoneBookContactPending: boolean,
    removeFromPhoneBookContactSuccess: boolean,
    removeContactPending: boolean,
    removeContactSuccess: boolean,
    etContactCategoryPending: boolean,
    contactCategories: ContactCategoryDataObject | null,
    addContactCategoryPending: boolean,
    addContactCategorySuccess: boolean,
    updateContactCategoryPending: boolean,
    updateContactCategorySuccess: boolean,
    removeContactCategoryPending: boolean,
    removeContactCategorySuccess: boolean,
    getPhoneBooksPending: boolean,
    getPhoneBooksSuccess: boolean,
    phoneBooks: PhoneBookDataObject,
    getUnpagedPhonebookPending: boolean,
    getUnpagedPhonebookSuccess: boolean,
    unpagedPhonebook: PhoneBookDataObject,
    addPhoneBookPending: boolean,
    addPhoneBookSuccess: boolean,
    updatePhoneBookPending: boolean,
    updatePhoneBookSuccess: boolean,
    removePhoneBookPending: boolean,
    removePhoneBookSuccess: boolean,
    copyByPhonebookPending: boolean,
    copyByPhonebookSuccess: boolean,
    moveByPhonebookPending: boolean,
    moveByPhonebookSuccess: boolean,
    moveByContactPending: boolean,
    moveByContactSuccess: boolean,
    copyByContactPending: boolean,
    copyByContactSuccess: boolean,
    contactListToBlockPending: boolean,
    contactListToBlockSuccess: boolean,
    selectedContactCategory: ContactCategory | null
}